<div class="dropdown profile-element">
  <ng-container *ngIf="userDetailsInDropdown">
    <div ngbDropdown #myDrop="ngbDropdown" role="group" [placement]="dropdownPlacement ?? 'bottom-end'">
      <div ngbDropdownToggle class="no-caret" style="display: inline-block; cursor: pointer">
        <shared-ui-profile-picture [size]="'48px'" [pictureFullPath]="imageUrl"></shared-ui-profile-picture>
      </div>
      <div class="dropdown-menu" ngbDropdownMenu>
        <ng-container *ngIf="!canOpenUserProfile || !userUid">
          <div class="px-3 apply-cursor-default">
            <ng-container *ngTemplateOutlet="headingAndSubheading"></ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="userUid && canOpenUserProfile">
          <div ngbDropdownItem [ngClass]="userUid && canOpenUserProfile ? 'apply-cursor-pointer' : 'apply-cursor-default'" (click)="openUserDashboard()">
            <ng-container *ngTemplateOutlet="headingAndSubheading"></ng-container>
          </div>
        </ng-container>
        <div class="dropdown-divider"></div>
        <ng-container *ngFor="let option of buttonOptions; let i = index">
          <button *ngIf="!!option.link" class="p-2" ngbDropdownItem [routerLink]="option.link">
            <shared-ui-icons-icon [iconName]="option.icon"></shared-ui-icons-icon>
            <span class="p-2 text-black-50">{{ option.label }} </span>
          </button>
          <button *ngIf="!option.link" class="p-2" ngbDropdownItem (click)="option.command()">
            <shared-ui-icons-icon [iconName]="option.icon"></shared-ui-icons-icon>
            <span class="p-2 text-black-50">{{ option.label }} </span>
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!userDetailsInDropdown"
    ><span>
      <shared-ui-profile-picture [size]="'48px'" [pictureFullPath]="imageUrl"></shared-ui-profile-picture>
    </span>
    <div class="apply-cursor-pointer">
      <span class="block m-t-xs text-white">
        <strong class="font-bold text-overflow no-padding" [title]="heading">{{ heading | truncate: 20 }}</strong>
      </span>
      <shared-ui-buttons-button-group *ngIf="buttonOptions" [options]="buttonOptions" [text]="'Update'" [type]="ButtonType.DefaultOutline">
        <span class="clear">
          <span class="text-xs block apply-subheading-color">
            <span>{{ subheading | truncate: 20 }}</span>
          </span>
        </span>
      </shared-ui-buttons-button-group>
    </div>
    <div class="logo-element">
      <shared-ui-profile-picture [size]="'30px'" [pictureFullPath]="imageUrl"></shared-ui-profile-picture>
    </div>
  </ng-container>
</div>
<ng-template #headingAndSubheading>
  <span class="block m-t-xs">
    <strong class="font-bold text-overflow no-padding" [title]="heading">{{ heading | truncate: 20 }}</strong>
  </span>
  <span class="clear">
    <span class="text-xs font-bold block apply-subheading-color">
      <span>{{ subheading | truncate: 20 }}</span>
    </span>
  </span>
</ng-template>
